import { css, keyframes } from 'styled-components';
const checkboxOn = keyframes `
  0% {
    box-shadow: 0 0 0 10px, 10px -10px 0 10px, 32px 0 0 20px, 0px 32px 0 20px,
      -5px 5px 0 10px, 15px 2px 0 11px;
  }
  50% {
    box-shadow: 0 0 0 10px, 10px -10px 0 10px, 32px 0 0 20px, 0px 32px 0 20px,
      -5px 5px 0 10px, 20px 2px 0 11px;
  }
  100% {
    box-shadow: 0 0 0 10px, 10px -10px 0 10px, 32px 0 0 20px, 0px 32px 0 20px,
      -5px 5px 0 10px, 20px -12px 0 11px;
  }
`;
const checkboxOff = keyframes `
  0% {
    box-shadow: 0 0 0 10px, 10px -10px 0 10px, 32px 0 0 20px, 0px 32px 0 20px,
      -5px 5px 0 10px, 20px -12px 0 11px, 0 0 0 0 inset;
  }
  25% {
    box-shadow: 0 0 0 10px, 10px -10px 0 10px, 32px 0 0 20px, 0px 32px 0 20px,
      -5px 5px 0 10px, 20px -12px 0 11px, 0 0 0 0 inset;
  }
  50% {
    transform: rotate(45deg);
    margin-top: -4px;
    margin-left: 6px;
    width: 0;
    height: 0;
    box-shadow: 0 0 0 10px, 10px -10px 0 10px, 32px 0 0 20px, 0px 32px 0 20px,
      -5px 5px 0 10px, 15px 2px 0 11px, 0 0 0 0 inset;
  }
  51% {
    transform: rotate(0deg);
    margin-top: -2px;
    margin-left: -2px;
    width: 20px;
    height: 20px;
    box-shadow: 0 0 0 0, 0 0 0 0, 0 0 0 0, 0 0 0 0, 0 0 0 0, 0 0 0 0,
      0px 0 0 10px inset;
  }
  100% {
    transform: rotate(0deg);
    margin-top: -2px;
    margin-left: -2px;
    width: 20px;
    height: 20px;
    box-shadow: 0 0 0 0, 0 0 0 0, 0 0 0 0, 0 0 0 0, 0 0 0 0, 0 0 0 0,
      0px 0 0 0 inset;
  }
`;
export const makeCustomField = () => {
    return `border: none;
          background: transparent;
          padding: 0;
          flex-direction: column;
          align-items: start;`;
};
export const makeCheckboxComponent = ({ fieldOptions }) => {
    const { size } = fieldOptions || 'medium';
    return `display: flex;
          position: relative;
          flex-direction: column;
          min-height:${size === 'small' ? '16px' : '20px'};
          min-width: ${size === 'small' ? '16px' : '20px'};`;
};
export const makeInput = ({ fieldOptions, theme }) => {
    const { size } = fieldOptions || 'medium';
    return css `
    display: none;
    position: relative;
    height: ${size === 'small' ? '16px' : '20px'};
    width: ${size === 'small' ? '16px' : '20px'} !important;

    &:not(:disabled) {
      &:focus ~ span,
      &:active ~ span {
        border: 0px solid ${theme.colors.secondary.lighten};
        background: transparent;
      }

      &:checked ~ span {
        border: 0px solid ${theme.colors.secondary.lighten};

        &:before {
          box-shadow: 0 0 0 10px, 10px -10px 0 10px, 32px 0 0 20px, 0 32px 0 20px, -5px 5px 0 10px, 20px -12px 0 11px;
          animation: ${checkboxOn} 0.3s forwards;
        }
      }
    }

    &:disabled {
      & ~ span {
        border: 0px solid rgba(0, 0, 24, 0.08);
      }
    }
  `;
};
export const makeOptionLabel = ({ disabled, fieldOptions, label }) => {
    const { size } = fieldOptions || 'medium';
    const paddingLeft = {
        withLabel: {
            small: '24px',
            large: '32px',
        },
        withoutLabel: {
            small: '16px',
            large: '20px',
        },
    };
    return `display: inline-block;
          padding-left: ${paddingLeft[label ? 'withLabel' : 'withoutLabel'][size === 'small' ? 'small' : 'large']};
          font-size: ${size === 'small' ? '14px' : '16px'};
          line-height: 20px;
          cursor: ${disabled ? 'not-allowed' : 'pointer'};
          position: relative;
          color: ${disabled ? 'rgba(0, 0, 24, 0.16)' : 'rgba(0, 0, 24, 0.84)'};
          min-height:${size === 'small' ? '16px' : '20px'};
          z-index: 10;`;
};
export const makeCheckmark = ({ fieldOptions, theme }) => {
    const { size } = fieldOptions || 'medium';
    return css `
    position: absolute;
    top: 50%;
    transform: translate(0%, -50%);
    left: 0;
    height: ${size === 'small' ? '16px' : '20px'};
    width: ${size === 'small' ? '16px' : '20px'};
    border-radius: 4px;
    border: 2px solid #ccc;
    overflow: hidden;

    &:before {
      position: absolute;
      content: '';
      transform: rotate(45deg);
      display: block;
      margin-top: ${size === 'small' ? '-4px' : '-2px'};
      margin-left: ${size === 'small' ? '6px' : '8px'};
      width: 0;
      height: 0;
      color: ${theme.colors.secondary.lighten};
      box-shadow: 0 0 0 0, 0 0 0 0, 0 0 0 0, 0 0 0 0, 0 0 0 0, 0 0 0 0, 0 0 0 0 inset;
      animation: ${checkboxOff};
    }
  `;
};
